"use client";

export default function KakaoMap() {
  return (
    <div className="mt-10 flex w-full justify-center">
      <div className="aspect-video w-full overflow-hidden rounded-md border-2 border-[#050505] bg-[#fffdf2] shadow-[7px_7px_0_rgba(140,0,0,0.16)]">
        <iframe
          src="/kakao-map.html"
          width="100%"
          height="100%"
          className="border-0"
          title="Kakao Map"
          loading="lazy"
        />
      </div>
    </div>
  );
}
